import React from "react"

const FashionSelected = () => (
    <div className="experiences__selected">
        <div className="container">
            <div className="has-text-white fashion__selected--columns">
                <div className="item--buttons">
                    <a
                        href=" https://experiences.global/access/fashion"
                        target="_blank" rel="noreferrer"
                        className="visit-website"
                    >
                        #AMEXGLOBALDESIGNERS
                    </a>
                </div>
                <div className="info px-0 mx-0">
                    <p className="pb-5">
                        Gain relevance related to your brand with the global
                        fashion creatives, executives, and designers.
                    </p>
                    <p className="pb-5">
                        Fashion is part of cultural and personal identity;
                        fashion speaks different languages and provides context
                        for social expression.
                    </p>
                    <p className="pb-5">
                        Whatever your client style, we have a fashion advisor
                        for them.
                    </p>
                </div>
            </div>
        </div>
    </div>
)

export default FashionSelected
